import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {tap} from "rxjs/operators";
import {Category} from "../../models/category";

@Injectable({
    providedIn: 'root'
})
export class CategoryService {

    public category: Category = null;
    public categories: Array<Category> = [];
    public onChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(
        private http: HttpClient,
    ) {}

    getAllMyCategories(projectId, databaseId) {
        return this.http.get(this.getPath(projectId, databaseId)).pipe(
            tap(data => this.categories = data['data']['categories'])
        )
    }

    postCategory(projectId, databaseId, category: Category) {
        return this.http.post(this.getPath(projectId, databaseId), category.getObj(true)).pipe(
            tap(
                data => {
                    this.category = new Category(data['data']['category']);
                    this.categories.push(this.category);
                    this.onChange.emit(true);
                }
            )
        );
    }

    getSingleCategory(projectId, databaseId, categoryId) {
        return this.http.get(this.getPath(projectId, databaseId) + '/' + categoryId).pipe(
            tap(
                data => {
                    this.category = new Category(data['data']['category']);

                    const index = this.categories.findIndex(m => m["_id"] === data['data']['category']['_id']);

                    if (index > -1)
                        this.categories[index] = this.category;
                    else
                        this.categories.push(this.category);

                    this.onChange.emit(true);
                }
            )
        );
    }

    patchCategory(projectId, databaseId, categoryId, category: Category) {
        return this.http.patch(this.getPath(projectId, databaseId) + '/' + categoryId, category.getObj(true)).pipe(
            tap(
                data => {
                    this.category = new Category(data['data']['category']);

                    const index = this.categories.findIndex(db => db["_id"] === categoryId);

                    if (index > -1)
                        this.categories[index] = this.category;
                    else
                        this.categories.push(this.category);

                    this.onChange.emit(true);
                }
            )
        );
    }

    deleteCategory(projectId, databaseId, categoryId) {
        return this.http.delete(this.getPath(projectId, databaseId) + '/' + categoryId).pipe(
            tap(
                () => {
                    if (this.category && this.category._id === categoryId)
                        this.category = null;

                    this.categories.splice(this.categories.findIndex(m => m["_id"] === categoryId), 1);

                    this.onChange.emit(true);
                }
            )
        );
    }

    private getPath(projectId, databaseId) {
        return '/api/v1/projects/' + projectId + '/databases/' + databaseId + '/categories';
    }
}
